<template>
    <div style="background-color: #f0f6fa;">
        <div style="position: relative;">
            <img src="@/images/experienceBanner.png" style="width: 100vw;height: 30.21vw;">
            <div class="topTitle">
                见心体验中心
            </div>
            <div class="topText">
                见心体验中心以"全生命周期心理健康关怀"为核心定位。
                科普区系统梳理人生八大阶段心理发展脉络，科普人生各阶段可能出现的心理问题。
                体验区打造场景化心理咨询体验矩阵，匹配并解决科普层所遇到的各种心理问题。
                打破传统心理咨询的单一治疗模式，创新打造"科普认知+沉浸体验"的双层空间结构。通过科学化、场景化、互动化的设计，构建覆盖人生八大阶段的心理健康知识体系，并建立"所见即所得"的即时咨询体验场景，形成"认知-体验-干预"的完整心理服务闭环。
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom: 1.5625vw">
                <div style="margin-bottom: 0.5208vw;padding-top: 3.5938vw;">
                    科普区
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    Popular Science Area
                </div>
            </div>
            <div
                style="display: flex;align-items: center;justify-content: center;flex-direction: column;position: relative;">
                <!-- 幼童阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper3.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg1.png" style="width: 3.75vw;height: 2.9167vw;">
                            <div class="boxLeftTitle">幼童</div>
                            <div>(0-6岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper1.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle">
                            安全感建立、情绪调节障碍、分离焦虑等
                        </div>
                        <div class="boxRigText">
                            幼童时期通过养育者稳定照料（如喂食、安抚）建立对世界的基本信任，若需求常被忽视，易产生不信任感
                        </div>
                    </div>
                </div>
                <!-- 小学阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper4.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg2.png" style="width: 3.75vw;height: 2.9167vw;">
                            <div class="boxLeftTitle">小学</div>
                            <div>(6-12岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper2.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle color-pink">
                            学习、人际关系、情绪、行为等
                        </div>
                        <div class="boxRigText">
                            学习中考试焦虑、厌学;人际中与成人关系紧张，同伴交往遇阻;情绪表现自卑、嫉妒;行为现品行问题、过度依赖;另伴随多动症、强迫症等
                        </div>
                    </div>
                </div>
                <!-- 初中阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper3.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg3.png" style="width: 3.75vw;height: 2.9167vw;">
                            <div class="boxLeftTitle">初中</div>
                            <div>(12-15岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper1.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle">
                            自我认知矛盾、情绪管理问题、学业压力焦虑、人际冲突、青春期困惑等
                        </div>
                        <div class="boxRigText">
                            易陷入自我认知矛盾，情绪波动大、叛逆;学业压力大,厌学心理;人际交往需求高，亲子沟通不畅，逆反心理强;青春期情感萌动,缺乏引导易困扰
                        </div>
                    </div>
                </div>
                <!-- 高中阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper4.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg4.png" style="width: 2.3958vw;height: 3.6979vw;">
                            <div class="boxLeftTitle">高中</div>
                            <div>(15-18岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper2.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle color-pink">
                            升学压力与未来焦虑、自我认同危机、情绪波动剧烈、人际矛盾升级、青春期心理冲突
                        </div>
                        <div class="boxRigText">
                            高考引发持续性焦虑，对未来方向的迷茫，情绪敏感脆弱，易抑郁或冲动;同伴关系复杂,亲子沟通易激化矛盾;青春期情感需求与责任感冲突,恋爱问题等
                        </div>
                    </div>
                </div>
                <!-- 大学阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper3.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg5.png" style="width: 3.75vw;height: 2.9167vw;">
                            <div class="boxLeftTitle">大学</div>
                            <div>(18-22岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper1.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle">
                            职业迷茫、价值观冲突、亲密关系困惑，社会角色转换
                        </div>
                        <div class="boxRigText">
                            探索“我是谁”，整合自我特质、目标与社会期待,形成自我认同;若未探索清晰,会陷入角色混乱,迷茫无方向
                        </div>
                    </div>
                </div>
                <!-- 青年就业阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper4.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg6.png" style="width: 3.75vw;height: 2.9167vw;">
                            <div class="boxLeftTitle">青年就业</div>
                            <div>(22-28岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper2.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle color-pink">
                            职业适应困境、经济压力焦虑、身份认同迷茫、社交关系疏离、未来不确定性
                        </div>
                        <div class="boxRigText">
                            社会角色转换期的适应性挑战，需通过增强心理韧性、构建支持系统及调整认知框架缓解压力
                        </div>
                    </div>
                </div>
                <!-- 成家立业阶段 -->
                <div style="margin-bottom: 3.3337vw;z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper3.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg7.png" style="width: 2.3958vw;height: 3.6979vw;">
                            <div class="boxLeftTitle">成家立业</div>
                            <div>(28-60岁)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper1.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle">
                            家庭责任与压力、职业发展瓶颈、中年危机与自我怀疑、健康焦虑与衰老恐惧等
                        </div>
                        <div class="boxRigText">
                            需平衡家庭、事业与自我需求,通过调整认知、提升应对能力及构建社会支持系统缓解压力
                        </div>
                    </div>
                </div>
                <!-- 中老年阶段 -->
                <div style="z-index: 2;display: flex;align-items: center;">
                    <div style="position: relative;margin-right: 0.6771vw;">
                        <img src="@/images/exper4.png" style="width: 8.6458vw;height: 8.6458vw;">
                        <div class="boxLeft">
                            <img src="@/images/experienceImg8.png" style="width: 2.3958vw;height: 3.6979vw;">
                            <div class="boxLeftTitle">中老年</div>
                            <div>(60以上)</div>
                        </div>
                    </div>
                    <div style="position: relative;">
                        <img src="@/images/exper2.png" style="width: 47.9688vw;height: 8.6458vw;">
                        <div class="boxRigTitle color-pink">
                            关注孤独感、生命意义感、积极老龄化心理应对
                        </div>
                        <div class="boxRigText">
                            回顾一生,若觉充实有意义,产生自我完善感;后悔过往则陷入绝望,恐惧死亡
                        </div>
                    </div>
                </div>
                <div class="line"></div>
            </div>
            <div style="height: 2.6042vw;"></div>
        </div>
        <div class="boxOne" style="margin-top: 2.6042vw">
            <div class="TitleCss" style="margin-bottom: 1.5625vw">
                <div style="margin-bottom: 0.5208vw;padding-top: 3.5938vw;">
                    体验区
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    Experience Area
                </div>
            </div>
            <div style="width: 57.1875vw;text-align-last: left;margin: 0 auto;font-size: 1.0417vw;color: #666666;">
                通过空间叙事与技术创新的深度融合，构建了完整的心理健康知识图谱，又创造了真实的心理干预体验场景，实现从被动接受到主动参与的心理服务范式转变。
            </div>
            <div class="box2Css" style="margin-top: 2.6042vw">
                <div style="position: relative;">
                    <img src="@/images/experienceImg9.png" style="width: 57.3958vw;height: 46.1458vw;">
                    <div style="position: absolute;left: 0;top: 0;">
                        <div v-for="(item, index) in experienceItems" :key="index"
                            style="display: flex;align-items: center;">
                            <div class="leftBox">
                                <span v-if="item.subText">{{ item.title }}</span>
                                <span v-else><text>{{ item.title }}</text><text class="leftText">{{ item.subText
                                }}</text></span>
                            </div>
                            <div class="conbox">
                                {{ item.content }}
                            </div>
                            <div class="rigBox" v-html="item.ageRange">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 2.6042vw;"></div>
        </div>
        <div style="height: 2.6042vw;"></div>
    </div>
</template>

<script>
export default {
    name: 'experiencePage',
    data() {
        return {
            experienceItems: [
                {
                    title: '团辐射',
                    subText: '',
                    content: '开展主题心理团辅、工作坊、亲子互动活动等',
                    ageRange: '全年龄段(6岁+)'
                },
                {
                    title: '个辅室',
                    subText: '(含心理测评室)',
                    content: '个体心理咨询、心理测评、职业规划指导等',
                    ageRange: '全年龄段(3岁+)'
                },
                {
                    title: '沙盘室',
                    subText: '(实景+电子)',
                    content: '通过非言语的方式,在安全的环境中表达内心,促进自我理解和整合',
                    ageRange: '儿童（3-18岁）为主'
                },
                {
                    title: '音乐放松室',
                    subText: '',
                    content: '音乐冥想治疗、自主神经调节训练等',
                    ageRange: '全年龄段(6岁+)'
                },
                {
                    title: '正念室',
                    subText: '(打坐冥想)',
                    content: '正念减压课程、专注力训练、情绪管理工作坊',
                    ageRange: '青少年(12岁+)至老年'
                },
                {
                    title: '宣泄室',
                    subText: '(人偶、摇水、互动仪)',
                    content: '情绪释放训练、压力管理课程、行为矫正',
                    ageRange: '青少年(13-25岁)为主'
                },
                {
                    title: 'VR产品体验室',
                    subText: '',
                    content: '恐惧症暴露治疗、创伤情境模拟训练、认知康复',
                    ageRange: '全年龄段(8岁+)'
                },
                {
                    title: '脑机室',
                    subText: '',
                    content: '注意力训练、焦虑水平调控、认知功能提升',
                    ageRange: '儿童(6-18岁) 老年(60 岁 +)'
                },
                {
                    title: '数字人室',
                    subText: '',
                    content: '24小时在线心理咨询、个性化治疗方案生成',
                    ageRange: '全年龄段(12岁+)'
                },
                {
                    title: '实景心理室',
                    subText: '',
                    content: '沟通训练、真实场景模拟治疗、社交技能训练',
                    ageRange: '青少年(15岁+)至老年'
                },
                {
                    title: '数据功能室',
                    subText: '查看各省市数据',
                    content: '心理危机预警、区域心理健康趋势分析、资源调度管理',
                    ageRange: '无直接年龄限制<br> (服务于全年龄段数据分析)'
                }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
.boxOne {
    width: 72.9167vw;
    margin: 0 auto;
    min-height: 33.5938vw;
    background: #fff;
    border-radius: 1.0417vw;
    margin-top: 5.2083vw;
}

.TitleCss {
    margin: 0 auto;
    text-align: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #0093E8;
}

.box2Css {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.line {
    position: absolute;
    width: 0.1042vw;
    left: 11.9792vw;
    top: 0;
    height: 99%;
    z-index: 1;
    border-left: 0.1042vw dotted #0093E8;
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #0093E8;
    position: absolute;
    left: 17.0833vw;
    top: 8.6458vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.0417vw;
    color: #666666;
    line-height: 1.875vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 17.0833vw;
    top: 11.875vw;
    width: 39.74vw;
}

.boxLeft {
    width: 8.6458vw;
    height: 8.6458vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.25vw;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    top: 0;
}

.boxLeftTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.4583vw;
    color: #FFFFFF;
    margin-top: 0.5208vw;
}

.boxRigTitle {
    font-family: NotoSansHans, NotoSansHans;
    font-weight: 600;
    font-size: 1.0938vw;
    color: #0093E8;
    position: absolute;
    left: 2.7604vw;
    top: 1.8229vw;
}

.boxRigTitle.color-pink {
    color: #FF78C1;
}

.boxRigText {
    font-family: NotoSansHans, NotoSansHans;
    font-weight: normal;
    font-size: 0.9896vw;
    color: #666666;
    line-height: 1.7188vw;
    width: 41.8229vw;
    position: absolute;
    left: 2.7604vw;
    top: 4.6354vw;
}

.leftBox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 10.7813vw;
    height: 4.1667vw;
    font-family: NotoSansHans, NotoSansHans;
    font-weight: 600;
    font-size: 0.9375vw;
    color: #444444;
}

.leftText {
    font-family: NotoSansHans, NotoSansHans;
    font-weight: 400;
    font-size: 0.9375vw;
    color: #ABABAB;
}

.conbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30.6771vw;
    height: 4.1667vw;
    font-family: NotoSansHans, NotoSansHans;
    font-weight: 500;
    font-size: 0.9375vw;
    color: #444444;
}

.rigBox {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 15.9375vw;
    height: 4.1667vw;
    font-family: NotoSansHans, NotoSansHans;
    font-weight: bold;
    font-size: 0.9475vw;
    color: #0093E8;
}
</style>